"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Agency = void 0;
const index_1 = require("../index");
const IdentityInfo_1 = __importDefault(require("../IdentityInfo"));
class Agency {
    constructor(type, data) {
        this.identityInfo = IdentityInfo_1.default.genFromList(type, data, [
            "OBJECTID",
            "Abbrev",
            null,
            "CD_ID",
            "SLDU_ID",
            "SLDL_ID",
        ]);
        this.NTD_ID = index_1.parseEsriString(data?.NTD_ID);
        //@ts-expect-error Data changed upstream adding additional check
        if (this.NTD_ID == null)
            this.NTD_ID = index_1.parseEsriString(data?.ntd_id);
        this.Agency_Name = index_1.parseEsriString(data?.Agency_Name);
        this.URL = index_1.parseEsriString(data?.URL);
        this.Service_Area_Sq_Miles = index_1.parseEsriNumber(data?.Service_Area_Sq_Miles);
        this.Service_Area_Pop = index_1.parseEsriNumber(data?.Service_Area_Pop);
    }
}
exports.Agency = Agency;
